import React, { useEffect, useState } from "react";
import { IListObj } from "../types/genericTypes";
import "../../assets/scss/components/generic/tocDropdown.scss";
import { useQuery } from "../service/urlHelper";

export interface ITocDropdownProps {
  selectedValue?: number | string; // default selected value
  dropdownOptions: Array<IListObj>; // list of all options in dropdown
  onSelect: (id: string | number) => void; // the function to be called onSelect
  showPrimary?: boolean; // true if need to show star, otherwise false
  showClose?: boolean; // true if need to show close button, otherwise false
  disabled?: boolean; //disable the dropdown
  isSearchable: boolean; // for searchable dropdown list
}

const TocDropdown: React.FC<ITocDropdownProps> = (props: ITocDropdownProps) => {
  /**
   * state and function for isDropdownOpen
   * selectedValue type is boolean
   * setSelectedValue(boolean)
   */
  const consentType = useQuery().get("consentType");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [dropDownOption, setDropDownOption] = useState<Array<IListObj>>();
  const [search, setSearch] = useState<any>();

  /**
   * called when user selects an option
   * @param id id of the selected option
   * @returns onSelect prop passed from parent
   */
  function optionSelected(id: string | number) {
    setIsDropdownOpen(false);
    return props.onSelect(id);
  }

  function handleChange(e: any) {
    let val = e.target.value.trim();
    setSearch(val.trimStart());
    const list = props.dropdownOptions.filter((opt) => {
      if (opt.display.toLowerCase().startsWith(val.trimStart().toLowerCase()))
        return opt;
    });
    if (!list.length)
      list.push({
        value: "",
        display: "No results",
      });
    setIsDropdownOpen(true);
    setDropDownOption(list);
  }
  // Find the selected object
  const selectedOption = props.dropdownOptions.find(
    (option) => props.selectedValue === option.value
  );
  useEffect(() => {
    const selectedOption = props.dropdownOptions.find(
      (option) => props.selectedValue === option.value
    );
    setSearch(selectedOption?.display);
    const options = props.dropdownOptions.filter(
      (opt) => props.selectedValue !== opt.value && opt.value
    );

    setDropDownOption(options);
    if (
      
      props.dropdownOptions.length === 0 ||
      (options?.length === 0 && !props.selectedValue)
    ) {
      setDropDownOption(
        options.concat({
          value: "",
          display: "No results",
        })
      );
    }
  }, [props.selectedValue, props.dropdownOptions]);

  return (
    <div className="dropdown_wrap">
      {props.isSearchable ? (
        <>
          <input
            id="tableDataSearchEle"
            autoFocus
            type="text"
            className="dropdown_button"
            onChange={handleChange}
            value={search ? search : ""}
            placeholder="Search"
            autoComplete="off"
          />
          <i
            className="edel-icon-arrow-down"
            onClick={() => setIsDropdownOpen(true)}
          />
        </>
      ) : (
        <button
          className="dropdown_button"
          onClick={(e) => {
            e.preventDefault();
            !(e as any).target.className.includes("edel-icon-close") &&
              setIsDropdownOpen(true);
          }}
          disabled={props.disabled}
          type={"button"}
        >
          {/* show the value of selectedValue */}
          <span className="selected">
            {selectedOption?.display === "NRML-SMTF Funds Movement Preference"
              ? "NRML-SMTF Funds Movement..."
              : selectedOption?.display}
            {/* Show star only if primary is to be shown and first option is selected */}
            {props.showPrimary && selectedOption?.primary && (
              <i className="star edel-icon-star" />
            )}
          </span>
          {props.showClose && props.selectedValue ? (
            <i className="edel-icon-close" onClick={() => optionSelected("")} />
          ) : (
            !consentType?.includes("nominee") && (
            <i className="edel-icon-arrow-down" />
            )
          )}
        </button>
      )}

      {/* when dropdown is open show overlay and content */}
      {isDropdownOpen && (
        <>
          {/* Overlay covers the whole screen. When overlay is clicked, close the dropdown. */}
          <div
            className="dropdown_overlay"
            onClick={() => setIsDropdownOpen(false)}
          />

          {/* Dropdown list */}
          {!(props.dropdownOptions.length === 1 && props.selectedValue)  && <ul className="dropdown_content">
            {dropDownOption &&
              dropDownOption.length > 0 &&
              dropDownOption.map((option, index) => (
                <li
                  className={
                    "dropdown_item" +
                    (option.value === props.selectedValue ? " active" : "")
                  }
                  key={index}
                  onClick={() => {
                    if (option.value) optionSelected(option.value);
                  }}
                >
                  <div className="dropdown_item_inner">
                    <div>
                      {/* show tick only if this option is selected */}
                      <span className="tick_container">
                        {option.value === props.selectedValue && (
                          <i className="tick edel-icon-tick" />
                        )}
                      </span>
                      <label>{option.display}</label>
                    </div>
                    {option.primary && props.showPrimary && (
                      <div>
                        <i className="star edel-icon-star" />
                      </div>
                    )}
                  </div>
                </li>
              ))}
          </ul>}
          
        </>
      )}
    </div>
  );
};

export default TocDropdown;
